// Shared formatters (Curro redesign) — en-ZA, true minus sign for credits.

export const fmtR = (v) => (v < 0 ? "−R" : "R") + Math.round(Math.abs(v)).toLocaleString("en-ZA");
export const fmtRm = (v) => `${v < 0 ? "−" : ""}R${(Math.abs(v) / 1e6).toFixed(1)}m`;
export const fmtN = (v) => Math.round(v).toLocaleString("en-ZA");
export const fmtPct = (v) => `${v.toFixed(1)}%`;

// Curro chart palette (parts-of-a-whole + categorical bars).
export const PALETTE = ["#0072CE", "#00A9E0", "#7C5CCB", "#1FA86A", "#FFC629", "#EC6BA9", "#F0563F", "#0AA6B8", "#9AA7C7"];
